import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { SiteType, LoginUser } from '../api/api';
import { PLAY_MODE } from '../constants/Consts';

export const isSoundEnabledAtom = atom<boolean>(false);

export const showSoundContolModalAtom = atom<boolean>(true);

export const userAtom = atom<LoginUser | undefined>(undefined);

export const isOnlineUserAtom = atom((get) => {
  const user = get(userAtom);
  return user?.siteName === SiteType.Online;
});

export const activeCoursesAtom = atom<string[] | undefined>(undefined);

const playModeStorage = createJSONStorage<PLAY_MODE>(() => sessionStorage);
export const playModeAtom = atomWithStorage<PLAY_MODE>('playMode', PLAY_MODE.NORMAL, playModeStorage, {
  getOnInit: true,
});

export const isFreeModeAtom = atom((get) => {
  return get(playModeAtom) === PLAY_MODE.FREE;
});
